import CheckoutNextSteps from '~/themes/oknadverenamiru/components/cart/CheckoutNextSteps'
import ContactBox from '~/themes/oknadverenamiru/components/shop/ContactBox'
import FileBox from '~/themes/oknadverenamiru/components/content/FileBox'
import PageFaq from '~/themes/base/components/content/PageFaq'
import PageIntro from '~/themes/oknadverenamiru/components/shop/PageIntro'

export default {
  extends: PageFaq,
  components: {
    CheckoutNextSteps,
    FileBox,
    PageIntro,
    ContactBox,
  },
}
